/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useMemo, useEffect, useState } from "react";

// action buttons
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import React from "react";
import {Stack} from "@mui/material"
import download from "assets/icons/download_icon.png";
import useMediaQuery from '@mui/material/useMediaQuery';
// import { Icon } from '@iconify/react';
import Grid from "@mui/material/Unstable_Grid2";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// react-table components
import {
  useTable,
  usePagination,
  useGlobalFilter,
  useAsyncDebounce,
  useSortBy,
  useFilters,
} from "react-table";

// @mui material components
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftSelect from "components/SoftSelect";
import SoftInput from "components/SoftInput";
import SoftPagination from "components/SoftPagination";
import { DefaultColumnFilter } from "components/Filter/Filter";

// Soft UI Dashboard PRO React example components
import DataTableHeadCell from "examples/Tables/DataTable/DataTableHeadCell";
import DataTableBodyCell from "examples/Tables/DataTable/DataTableBodyCell";

import Popover from "@material-ui/core/Popover";

function DataTable({
  entriesPerPage,
  canSearch,
  showTotalEntries,
  table,
  pagination,
  isSorted,
  noEndBorder,
}) {
  const defaultValue = entriesPerPage.defaultValue ? entriesPerPage.defaultValue : 10;
  const entries = entriesPerPage.entries ? entriesPerPage.entries : [5, 10, 15, 20, 25];
  const columns = useMemo(() => table.columns, [table]);
  const data = useMemo(() => table.rows, [table]);
  const defaultColumn = useMemo(
    () => ({
      // set up our default Filter UI
      Filter: DefaultColumnFilter,
    }),
    []
  );

  const tableInstance = useTable(
    { columns, data, initialState: { pageIndex: 0 }, defaultColumn },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    rows,
    page,
    pageOptions,
    canPreviousPage,
    canNextPage,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    setGlobalFilter,
    state: { pageIndex, pageSize, globalFilter },
  } = tableInstance;

  // for popover
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl); 


  // Set the default value for the entries per page when component mounts
  useEffect(() => setPageSize(defaultValue || 10), [defaultValue]);

  // Set the entries per page value based on the select value
  const setEntriesPerPage = ({ value }) => setPageSize(value);

  // Render the paginations
  const renderPagination = pageOptions.map((option) => (
    <SoftPagination
      item
      key={option}
      onClick={() => gotoPage(Number(option))}
      active={pageIndex === option}
    >
      {option + 1}
    </SoftPagination>
  ));

  // Handler for the input to set the pagination index
  const handleInputPagination = ({ target: { value } }) =>
    value > pageOptions.length || value < 0 ? gotoPage(0) : gotoPage(Number(value));

  // Customized page options starting from 1
  const customizedPageOptions = pageOptions.map((option) => option + 1);

  // Setting value for the pagination input
  const handleInputPaginationValue = ({ target: value }) => gotoPage(Number(value.value - 1));

  // Search input value state
  const [search, setSearch] = useState(globalFilter);

  // Search input state handle
  const onSearchChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 100);

  // A function that sets the sorted value for the table
  const setSortedValue = (column) => {
    let sortedValue;

    if (isSorted && column.isSorted) {
      sortedValue = column.isSortedDesc ? "desc" : "asce";
    } else if (isSorted) {
      sortedValue = "none";
    } else {
      sortedValue = false;
    }

    return sortedValue;
  };

  // Setting the entries starting point
  const entriesStart = pageIndex === 0 ? pageIndex + 1 : pageIndex * pageSize + 1;

  // Setting the entries ending point
  let entriesEnd;

  if (pageIndex === 0) {
    entriesEnd = pageSize;
  } else if (pageIndex === pageOptions.length - 1) {
    entriesEnd = rows.length;
  } else {
    entriesEnd = pageSize * (pageIndex + 1);
  }
  const breakpoint = useMediaQuery('(min-width:700px)');

  const downloadCSVfile = ()=>{
    const element = document.createElement("a");
    const file = new Blob([`Data  table to be downloaded`], { type: 'text/plain' });
    element.href = URL.createObjectURL(file);
    element.download = getCsvFileName();
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
    // setTimeout(()=>{
    //   showAlert();
    // },5000)

  }
  const downloadEXCEfile = ()=>{
    const element = document.createElement("a");
    const file = new Blob([`Data  table to be downloaded`], { type: 'text/plain' });
    element.href = URL.createObjectURL(file);
    element.download = getExcelFileName();
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
    // setTimeout(()=>{
    //   showAlert();
    // },5000)

  }
  const getCsvFileName =()=>{

    let d = new Date();
    let dformat = `${d.getHours()}-${d.getMinutes()}-${d.getSeconds()}`;

    console.log("getCurrentDate : ", dformat);
    return "Master_data_" + dformat + ".csv";
  }
  const getExcelFileName =()=>{

    let d = new Date();
    let dformat = `${d.getHours()}-${d.getMinutes()}-${d.getSeconds()}`;

    console.log("getCurrentDate : ", dformat);
    return "Master_data_" + dformat + ".xlsx";
  }

  return (
    <>
    <TableContainer sx={{ boxShadow: "none" }}>
      {entriesPerPage || canSearch ? (
        <SoftBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
          {/* {entriesPerPage && (
            <SoftBox display="flex" alignItems="center">
              <SoftSelect
                defaultValue={{ value: defaultValue, label: defaultValue }}
                options={entries.map((entry) => ({ value: entry, label: entry }))}
                onChange={setEntriesPerPage}
                size="small"
              />
              <SoftTypography variant="caption" color="secondary">
                &nbsp;&nbsp;entries per page
              </SoftTypography>
            </SoftBox>
          )} */}
          {canSearch && (
            !breakpoint ? (
              <SoftBox display="flex" flexDirection="column" >
              {/* <Grid container> */}
                {/* <Grid item lg={6} md={6} xs={12} spacing={3}> */}
                  <SoftBox width="337px" ml="" height="35px" >
                    <SoftInput
                      placeholder="Search..."
                      value={search}
                      onChange={({ currentTarget }) => {
                        setSearch(search);
                        onSearchChange(currentTarget.value);
                      }}
                      width="337px" height="35px" sx={{border:"1px solid #C4C4C4",borderRadius:"50px"}}
                    />
                  </SoftBox>
                {/* </Grid> */}
                {/* <Grid item lg={6} md={6} xs={12}  spacing={3}> */}
                <SoftBox  mt="30px">
                  <Stack spacing={1} direction="row">
                    <PopupState variant="popover" popupId="demo-popup-menu">
                      {(popupState) => (
                        <React.Fragment>
                          <Button
                            variant="contained"
                            sx={{
                              color: "white !important",
                              backgroundColor: "#81BBFF",
                              width: "104px",
                              height: "35px",
                            }}
                            {...bindTrigger(popupState)}
                          >
                            {" "}
                            Action
                          </Button>
                          <Menu {...bindMenu(popupState)}>
                            <MenuItem onClick={popupState.close}>
                              <Icon icon="mdi:lead-pencil" inline={true} /> &nbsp;Modify
                            </MenuItem>
                            <MenuItem onClick={popupState.close}>
                              <Icon icon="ic:round-delete-forever" inline={true} />
                              &nbsp;Deactivate
                            </MenuItem>
                          </Menu>
                        </React.Fragment>
                      )}
                    </PopupState>

                    <SoftBox
                      display="flex"
                      flexDirection="row"
                      justifyContent="center"
                      alignItems="center"
                      gap="10px"
                      variant="contained"
                      sx={{
                        backgroundColor: "#111727",
                        width: "156px",
                        height: "40px",
                        padding: "8px 26px",
                        borderRadius: "5px",
                      }}
                    >
                      <SoftBox
                        component="img"
                        src={download}
                        flex="none"
                        flexGrow="0"
                        order="0"
                        width="15px"
                      />
                      {/* <SoftTypography sx={{color:"#fff",fontSize:"15px"}} flex="none" flexGrow="1" order="1">Download</SoftTypography> */}
                      <PopupState variant="popover" popupId="demo-popup-menu">
                        {(popupState) => (
                          <React.Fragment>
                            {/* {...bindTrigger(popupState)} onClick={popupState.open}*/}
                            <Button
                              sx={{ color: "white !important", fontSize: "15px" }}
                              {...bindTrigger(popupState)}
                            >
                              Download
                            </Button>
                            <Menu {...bindMenu(popupState)}>
                              <MenuItem onClick={
                                // popupState.close
                                ()=> downloadEXCEfile()
                                // console.log("exce file")
                                }>
                                {/* <Icon icon="mdi:file" inline={true} /> */}
                                 excel file
                              </MenuItem>
                              <MenuItem onClick={
                                // popupState.close
                                ()=> downloadCSVfile() 
                                // console.log("csv file")                               
                              }>
                                {/* <Icon icon="mdi:file" inline={true} /> */}
                                csv file
                              </MenuItem>
                            </Menu>
                          </React.Fragment>
                        )}
                      </PopupState>
                    </SoftBox>
                  </Stack>
                </SoftBox>
                {/* </Grid> */}
              {/* </Grid> */}
              </SoftBox>
            ) :
            (
              <SoftBox display="flex" flexDirection="row" >
              {/* <Grid container> */}
                {/* <Grid item lg={6} md={6} xs={12} spacing={3}> */}
                  <SoftBox width="337px" ml="" height="35px" >
                    <SoftInput
                      placeholder="Search..."
                      value={search}
                      onChange={({ currentTarget }) => {
                        setSearch(search);
                        onSearchChange(currentTarget.value);
                      }}
                      width="337px" height="35px" sx={{border:"1px solid #C4C4C4",borderRadius:"50px"}}
                    />
                  </SoftBox>
                {/* </Grid> */}
                {/* <Grid item lg={6} md={6} xs={12}  spacing={3}> */}
                <SoftBox position="absolute" ml={{ lg:"70%",md:"55%", sm: "57%", xs: "0px" }}>
                  <Stack spacing={1} direction="row">
                    <PopupState variant="popover" popupId="demo-popup-menu">
                      {(popupState) => (
                        <React.Fragment>
                          <Button
                            variant="contained"
                            sx={{
                              color: "white !important",
                              backgroundColor: "#81BBFF",
                              width: "104px",
                              height: "35px",
                            }}
                            {...bindTrigger(popupState)}
                          >
                            {" "}
                            Action
                          </Button>
                          <Menu {...bindMenu(popupState)}>
                            <MenuItem onClick={popupState.close}>
                              <Icon icon="mdi:lead-pencil" inline={true} /> &nbsp;Modify
                            </MenuItem>
                            <MenuItem onClick={popupState.close}>
                              <Icon icon="ic:round-delete-forever" inline={true} />
                              &nbsp;Deactivate
                            </MenuItem>
                          </Menu>
                        </React.Fragment>
                      )}
                    </PopupState>

                    <SoftBox
                      display="flex"
                      flexDirection="row"
                      justifyContent="center"
                      alignItems="center"
                      gap="10px"
                      variant="contained"
                      sx={{
                        backgroundColor: "#111727",
                        width: "156px",
                        height: "40px",
                        padding: "8px 26px",
                        borderRadius: "5px",
                      }}
                    >
                      <SoftBox
                        component="img"
                        src={download}
                        flex="none"
                        flexGrow="0"
                        order="0"
                        width="15px"
                      />
                      {/* <SoftTypography sx={{color:"#fff",fontSize:"15px"}} flex="none" flexGrow="1" order="1">Download</SoftTypography> */}
                      
                      <PopupState variant="popover" popupId="demo-popup-menu">
                        {(popupState) => (
                          <React.Fragment>
                            {/* {...bindTrigger(popupState)} onClick={popupState.open}*/}
                            <Button
                              sx={{ color: "white !important", fontSize: "15px" }}
                              {...bindTrigger(popupState)}
                            >
                              Download
                            </Button>
                            <Menu {...bindMenu(popupState)}>
                              <MenuItem onClick={
                                // popupState.close
                                ()=> downloadEXCEfile()
                                // console.log("exce file")
                                }>
                                {/* <Icon icon="mdi:file" inline={true} /> */}
                                 excel file
                              </MenuItem>
                              <MenuItem onClick={
                                // popupState.close
                                ()=> downloadCSVfile() 
                                // console.log("csv file")                               
                              }>
                                {/* <Icon icon="mdi:file" inline={true} /> */}
                                csv file
                              </MenuItem>
                            </Menu>
                          </React.Fragment>
                        )}
                      </PopupState>

                      {/* <Button
                        sx={{ color: "white !important", fontSize: "15px" }}
                        onClick={(event) => {
                        setAnchorEl(event.currentTarget);
                        }}
                      >
                        Download
                      </Button>
                      <Popover
                        anchorEl={anchorEl}
                        open={open}
                        id={open ? "simple-popover" : undefined}
                        onClose={() => {
                        setAnchorEl(null);
                        }}
                        transformOrigin={{
                        horizontal: "center",
                        vertical: "top",
                        }}
                        anchorOrigin={{
                        horizontal: "center",
                        vertical: "bottom",
                        }}
                      >
                        <div onClick={()=>{console.log("option1");setAnchorEl(null);}}>Excel file</div>
                        <div onClick={()=>{console.log("option2");setAnchorEl(null);}}>csv file</div>
                      </Popover> */}
                    </SoftBox>
                  </Stack>
                </SoftBox>
                {/* </Grid> */}
              {/* </Grid> */}
              </SoftBox>
            )
          )}
        </SoftBox>
      ) : null}
      <Table {...getTableProps()} sx={{ height: "1em" }}>
        <SoftBox component="thead">          
            {headerGroups.map((headerGroup, key) => (
              <TableRow key={key} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, key) => (
                  <DataTableHeadCell
                    key={key}
                    width={column.width ? column.width : "auto"}
                    align={column.align ? column.align : "left"}
                    sorted={setSortedValue(column)}
                  >
                    <SoftBox
                      height="100%"
                      display="flex"
                      flexDirection="column"
                      justifyContent="space-between"
                      fontWeight="medium"
                      fontSize="15px"                    
                    >
                      <SoftBox
                        {...column.getHeaderProps(isSorted && column.getSortByToggleProps())}
                        opacity={1}
                        color="black"
                        fontWeight="large"
                        fontSize="15px"
                      >
                        {column.render("Header")}
                      </SoftBox>
                      <SoftBox>
                        {column.canFilter ? column.render("Filter") : <SoftBox></SoftBox>}
                      </SoftBox>
                    </SoftBox>
                  </DataTableHeadCell>
                ))}
              </TableRow>
            ))}
          
        </SoftBox>
        <TableBody {...getTableBodyProps()}>
          {page.map((row, key) => {
            prepareRow(row);
            return (
              <TableRow key={key} {...row.getRowProps()}>
                {row.cells.map((cell, key) => (
                  <DataTableBodyCell
                    key={key}
                    noBorder={noEndBorder && rows.length - 1 === key}
                    align={cell.column.align ? cell.column.align : "left"}
                    {...cell.getCellProps()}
                  >
                    {cell.render("Cell")}
                  </DataTableBodyCell>
                ))}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>

      
    </TableContainer>
    <SoftBox
      display="flex"
      flexDirection={{ xs: "column", sm: "row" }}
      justifyContent="space-between"
      alignItems={{ xs: "flex-start", sm: "center" }}
      // p={!showTotalEntries && pageOptions.length === 1 ? 0 : 3}
      mt="21px"
    >
      {showTotalEntries && (
        <SoftBox mb={{ xs: 3, sm: 0 }}>
          <SoftTypography variant="button" color="secondary" fontWeight="regular">
            Showing {entriesStart} to {entriesEnd} of {rows.length} entries
          </SoftTypography>
        </SoftBox>
      )}
      {pageOptions.length > 1 && (
        <SoftPagination
          // variant={pagination.variant ? pagination.variant : "gradient"}
          // color={pagination.color ? pagination.color : "info"}
        >
          {canPreviousPage && (
            <SoftPagination item onClick={() => previousPage()}>
              <Icon sx={{ fontWeight: "bold" }}>chevron_left</Icon>
            </SoftPagination>
          )}
          {renderPagination.length > 6 ? (
            <SoftBox width="5rem" mx={1}>
              <SoftInput
                inputProps={{ type: "number", min: 1, max: customizedPageOptions.length }}
                value={customizedPageOptions[pageIndex]}
                onChange={(handleInputPagination, handleInputPaginationValue)}
              />
            </SoftBox>
          ) : (
            renderPagination
          )}
          {canNextPage && (
            <SoftPagination item onClick={() => nextPage()}>
              <Icon sx={{ fontWeight: "bold" }}>chevron_right</Icon>
            </SoftPagination>
          )}
        </SoftPagination>
      )}
    </SoftBox>
  </>
  );
}

// Setting default values for the props of DataTable
DataTable.defaultProps = {
  entriesPerPage: { defaultValue: 10, entries: [5, 10, 15, 20, 25] },
  canSearch: false,
  showTotalEntries: true,
  pagination: { variant: "gradient", color: "info" },
  isSorted: true,
  noEndBorder: false,
};

// Typechecking props for the DataTable
DataTable.propTypes = {
  entriesPerPage: PropTypes.oneOfType([
    PropTypes.shape({
      defaultValue: PropTypes.number,
      entries: PropTypes.arrayOf(PropTypes.number),
    }),
    PropTypes.bool,
  ]),
  canSearch: PropTypes.bool,
  showTotalEntries: PropTypes.bool,
  table: PropTypes.objectOf(PropTypes.array).isRequired,
  pagination: PropTypes.shape({
    variant: PropTypes.oneOf(["contained", "gradient"]),
    color: PropTypes.oneOf([
      "primary",
      "secondary",
      "info",
      "success",
      "warning",
      "error",
      "dark",
      "light",
    ]),
  }),
  isSorted: PropTypes.bool,
  noEndBorder: PropTypes.bool,
};

export default DataTable;
